// src/routes.js

import React from 'react';
import { Provider } from 'react-redux';
import { Route, Router } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ThemeProvider } from '@mui/material/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MsalProvider } from '@azure/msal-react';

import Operator from '../Operator';
import Login from '../components/login';
import MarketPage from '../components/operator/market-page';
import MarketTabs, {
  VEHICLES_TAB,
  REPAIRS_TAB,
  FIELD_TAB,
  LOCATIONS_TAB,
  ZONES_TAB,
  DASHBOARD_TAB,
  VEHICLE_ZONES_TAB,
  RUN_MANAGER_TAB,
  MAP_TAB,
  USERS_TAB,
  SETTINGS_TAB,
} from '../components/operator/market-tabs';
import UserAdmin from '../components/operator/user-admin';
import ReportsPage from '../components/operator/reports/reports-page';
import InventoryReport from '../components/operator/reports/inventory-table';
import { RidePage } from '../components/operator/reports/ride-report-page';
import ZoneDeploymentTable from '../components/operator/reports/zone-deployment-table';
import DeploymentProgressPage from '../components/operator/reports/deployment-progress-page';
import VehicleTripsTable from '../components/operator/vehicle-trips';
import { RepairTicketPage } from '../components/operator/reports/repair-ticket-report-page';
import { RepairsByCategoryPage } from '../components/operator/reports/repairs-by-category-report-page';
import { LoginError } from '../components/login-callback';
import Auth from './auth';
import history from './history';
import store from '../store';
import wranglerTheme from '../theme';
import {
  MARKET_ID_PARAM,
  VEHICLE_ID_PARAM,
  GET_MARKET_VEHICLE,
  GET_MARKET_VEHICLE_TRIPS,
  GET_DASHBOARD,
} from './routes/routeHelper';

const auth = new Auth();

export default function makeMainRoutes(msalInstance) {
  return (
    <GoogleOAuthProvider clientId="563368893203-cnmtaqhjql19emhald429a34d9ipnquf.apps.googleusercontent.com">
      <MsalProvider instance={msalInstance}>
        <ThemeProvider theme={wranglerTheme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Provider store={store}>
              <Router history={history}>
                <div>
                  <Route
                    exact
                    path="/"
                    render={(props) => (
                      <Login
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/home"
                    render={(props) => (
                      <Operator
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/operator"
                    render={(props) => (
                      <Operator
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/users"
                    render={(props) => (
                      <UserAdmin
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets"
                    render={(props) => (
                      <MarketPage
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId"
                    render={(props) => (
                      <MarketTabs
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/vehicles"
                    render={(props) => (
                      <MarketTabs
                        value={VEHICLES_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path={GET_MARKET_VEHICLE_TRIPS(MARKET_ID_PARAM, VEHICLE_ID_PARAM)}
                    render={(props) => (
                      <VehicleTripsTable
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path={GET_MARKET_VEHICLE(MARKET_ID_PARAM, VEHICLE_ID_PARAM)}
                    render={(props) => (
                      <MarketTabs
                        value={VEHICLES_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path={GET_DASHBOARD(MARKET_ID_PARAM)}
                    render={(props) => (
                      <MarketTabs
                        value={DASHBOARD_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/repairs"
                    render={(props) => (
                      <MarketTabs
                        value={REPAIRS_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/repairs/:repairTicketId"
                    render={(props) => (
                      <MarketTabs
                        value={REPAIRS_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/fieldreports"
                    render={(props) => (
                      <MarketTabs
                        value={FIELD_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/locations"
                    render={(props) => (
                      <MarketTabs
                        value={LOCATIONS_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/zones"
                    render={(props) => (
                      <MarketTabs
                        value={ZONES_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/runs"
                    render={(props) => (
                      <MarketTabs
                        value={RUN_MANAGER_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  {/* DEPRECATED <Route exact path="/operator/markets/:marketId/routes" render={props => <MarketTabs value={ROUTES_TAB} auth={auth} {...props} />} /> */}
                  <Route
                    exact
                    path="/operator/markets/:marketId/map"
                    render={(props) => (
                      <MarketTabs
                        value={MAP_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/users"
                    render={(props) => (
                      <MarketTabs
                        value={USERS_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/settings"
                    render={(props) => (
                      <MarketTabs
                        value={SETTINGS_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/markets/:marketId/vehicleZones"
                    render={(props) => (
                      <MarketTabs
                        value={VEHICLE_ZONES_TAB}
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/reports"
                    render={(props) => (
                      <ReportsPage
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/reports/inventory"
                    render={(props) => <InventoryReport {...props} />}
                  />
                  <Route
                    exact
                    path="/operator/reports/deploys"
                    render={(props) => <ZoneDeploymentTable {...props} />}
                  />
                  <Route
                    exact
                    path="/operator/reports/deployProgress"
                    render={(props) => (
                      <DeploymentProgressPage
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/operator/reports/repairTickets"
                    render={(props) => <RepairTicketPage {...props} />}
                  />
                  <Route
                    exact
                    path="/operator/reports/repairsByCategory"
                    render={(props) => <RepairsByCategoryPage {...props} />}
                  />
                  <Route
                    exact
                    path="/operator/reports/rides"
                    render={(props) => (
                      <RidePage
                        auth={auth}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/login-error"
                    render={(props) => <LoginError {...props} />}
                  />
                </div>
              </Router>
            </Provider>
          </LocalizationProvider>
        </ThemeProvider>
      </MsalProvider>
    </GoogleOAuthProvider>
  );
}
